import { toast } from "react-toastify";
import { push } from 'react-router-redux';

const actionTypes = {
    PROFILE_GET_REQUEST: 'PROFILE_GET_REQUEST',
    PROFILE_GET_RESPONSE: 'PROFILE_GET_RESPONSE',
    PROFILE_UPDATE_RESPONSE: 'PROFILE_UPDATE_RESPONSE',
};

export const getUserProfile = () => async (dispatch, getState) => {
    const url = `api/Account/getuserprofile`;

    fetch(url, {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getState().account.user.token
        }
    })
        .then(handleResponse)
        .then(
            result => {
                dispatch({
                    type: actionTypes.PROFILE_GET_RESPONSE,
                    payload: { userDetail: result, isLoading: false }
                });
            },
            error => {
                if (error.status === 401) {
                    dispatch(push('/login'));
                } else {
                    toast.warn("Error:" + error.error, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                }
            }
        );

};

export const saveUserProfile = (state) => async (dispatch, getState) => {

    var token = getState().account.user.token;
    const url = `api/Account/setuserprofile`;
    return fetch(url, {
        method: 'post',
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json; charset=UTF-8',
            'Accept': 'application/json',
        },
        body: JSON.stringify({
            "PersonelName": state.Name,
            "PersonelSurname": state.SurName,
            "PhoneNumber": state.PhoneNumber,
            "PhoneExtention": state.PhoneExtention,
            "Email": state.Email,
            "Password": ""
        })

    })
        .then(handleResponse)
        .then(
            result => {
                dispatch({ type: actionTypes.PROFILE_UPDATE_RESPONSE, updateResponse: result });
                toast.success("Profile successfully updated !", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
                return result;
            },
            error => {
                if (error.status === 401) {
                    dispatch(push('/login'));
                } else {
                    toast.warn("Houston we have a problem !");
                    return error.error;
                }
            }
        );
};

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                return Promise.reject({ status: response.status });
            }
            const error = text;
            return Promise.reject({ status: response.status, error });
        }
        return data;
    });
}




// WEBPACK FOOTER //
// ./src/actions/ProfileAction.js